import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { useIsLoggedOutHomepageRedesignV2, useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { WeMakeItSimpleRightImage } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/WeMakeItSimpleBanner/__internal__/WeMakeItSimpleRightImage";
import * as componentStyles from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/WeMakeItSimpleBanner/styles.css";
import { RenderWithBuilder } from "@faire/web--source/builder/BuilderComponents/RenderWithBuilder";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackLoggedOutRetailersHomePageBannerInsiderMembershipButtonClick } from "@faire/web-api--source/events/loggedOutRetailers/click/homePageBannerInsiderMembershipButton";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import insiderMarketingPage from "@faire/web-api--source/routes/insider";
import classNames from "classnames";
import React from "react";
export var WeMakeItSimpleBanner = function() {
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var trackEvent = function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("we_make_it_simple_banner", "".concat(homepageRedesignVariant));
    };
    var ref = useDoActionWhenVisible(trackEvent);
    var isHomepageRedesignV2 = useIsLoggedOutHomepageRedesignV2();
    if (isHomepageRedesignV2) {
        return /*#__PURE__*/ _jsx(RenderWithBuilder, {
            modelName: "logged-out-homepage-new-brand-perks-banner",
            onViewEvent: trackEvent
        });
    }
    return /*#__PURE__*/ _jsxs(Flex, {
        direction: {
            mobileAndAbove: "column",
            tabletAndAbove: "row"
        },
        className: componentStyles.container,
        "data-test-id": "we-make-it-simple-banner",
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "w-full md:w-1/2",
                style: {
                    height: "100%",
                    alignContent: "center"
                },
                children: /*#__PURE__*/ _jsx(LeftContent, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames("relative w-full md:w-1/2", componentStyles.imageContainer),
                children: /*#__PURE__*/ _jsx(WeMakeItSimpleRightImage, {})
            })
        ]
    });
};
var Paragraph = function(param) {
    var number = param.number, content = param.content;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "subheadingSansMedium",
                    tabletAndAbove: "paragraphSansMedium",
                    desktopAndAbove: "subheadingSansMedium"
                },
                children: number
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "subheadingSansRegular",
                    tabletAndAbove: "paragraphSansRegular",
                    desktopAndAbove: "subheadingSansRegular"
                },
                children: content
            })
        ]
    });
};
var LeftContent = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var hasAccessToLoggedOutInsiderMarketingPage = useInsiderFeatureEligibility().hasAccessToLoggedOutInsiderMarketingPage;
    var getThirdParagraphContent = function() {
        if (hasAccessToLoggedOutInsiderMarketingPage) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "eKBFPY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Unlock free shipping with thousands of brands with a Faire "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Insider membership"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: "."
                    }
                ],
                values: {
                    LinkFormatting: LinkFormatting
                }
            });
        } else {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "BWm0DT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Unlock free shipping with thousands of brands with a Faire Insider membership."
                    }
                ]
            });
        }
    };
    return /*#__PURE__*/ _jsxs(Column, {
        className: componentStyles.leftContent,
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    desktopAndAbove: "displayMSerifRegular"
                },
                children: [
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "oKelKM",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "We make it simple."
                            }
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x",
                        style: {
                            display: "inline-block"
                        }
                    }),
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "Tu3+M+",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "You make it yours."
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: "3x",
                    desktopAndAbove: "4x"
                }
            }),
            /*#__PURE__*/ _jsx(Paragraph, {
                number: "01",
                content: strictLocalize({
                    id: "DNY1t0",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Try new brands with confidence\u2014you\u2019ve got free, easy returns on all first orders."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: "3x",
                    desktopAndAbove: "4x"
                }
            }),
            /*#__PURE__*/ _jsx(Paragraph, {
                number: "02",
                content: strictLocalize({
                    id: "NMi0Jy",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Buy new inventory for your shop now and pay invoices 60 days later, with zero fees."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: "3x",
                    desktopAndAbove: "4x"
                }
            }),
            /*#__PURE__*/ _jsx(Paragraph, {
                number: "03",
                content: getThirdParagraphContent()
            })
        ]
    });
};
var LinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        onClick: trackLoggedOutRetailersHomePageBannerInsiderMembershipButtonClick,
        linkTo: insiderMarketingPage(),
        target: "_blank",
        style: {
            fontSize: "inherit"
        },
        children: chunks
    });
};
